module.exports = __webpack_public_path__ + "img/introduce-pk-bg.7a12cead.png";